import { initSentry } from '@unbooking/sentry';

const prefix = window.location.host.split('.')[0].toLowerCase();
const ENV = prefix === 'roadsafetyacademy' ? 'production' : prefix;
const ENABLE_SENTRY = ['dev', 'qa', 'production'].includes(ENV);

if (ENABLE_SENTRY) {
  initSentry({
    dsn: import.meta.env.VITE_SENTRY_DSN || 'https://94aeb4e94aa83903f09b2cbfac2b48bf@o274918.ingest.us.sentry.io/4507287987945472',
    environment: import.meta.env.VITE_ENV || ENV,
    serviceName: 'road-safety-ui',
  });
}
